<template>
    <a class="w-100 d-flex my-3" v-if="banner" :href="banner.banner.link" :target="openIn == 'new' ? '_blank' : '_self'">
        <img :src="bannerLink" class="mx-auto shadow img-fluid" :width="banner.options.width" :height="banner.options.height" style="max-width: 100%; max-height: 1000px"/>
    </a>
</template>

<script>
    export default {
        props: ['location'],
        data() {
            return {
                banners: window.app.banners,
                openIn: 'new'
            }
        },
        computed: {
            banner() {
                if(!Object.keys(this.banners).length) {
                    return null;
                }

                return this.banners.find(b => b.options.position == this.location);
            },
            bannerLink() {
                let link = `/images/banner/${this.banner.banner_id}?d=1`;

                let options = JSON.parse(this.banner.banner.options);

                for(const key in options) {
                    link += `&${key}=${options[key]}`;

                    if(key == 'openIn') {
                        this.openIn = options[key];
                    }
                }

                return link;
            }
        }
    }
</script>
